module.exports = __webpack_public_path__ + "product-pure-powder-capsule-09.jpg?d742357d3a849c4c58f75aedc9c308ed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-09.jpg
// module id = 91
// module chunks = 0